import { render, staticRenderFns } from "./ReportsWaterTesting.vue?vue&type=template&id=37a73f9c&"
import script from "./ReportsWaterTesting.vue?vue&type=script&lang=js&"
export * from "./ReportsWaterTesting.vue?vue&type=script&lang=js&"
import style0 from "./ReportsWaterTesting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports